import React, { useEffect } from 'react';
import axios from "axios";
import { observer } from "mobx-react";
import PrivateRoute from '../Routing/PrivateRoute'
import { saveAs as importedSaveAs } from 'file-saver';

//only used on unlock page for now
import { Switch } from 'react-router-dom';
import { getCookie } from "../Services/Authentication/AuthHelper";

async function downloadProductHelpFile(product) {
  const apiEndpoint = `/api/${product}Survey/getHelpFile`
  const config = {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + getCookie("access_token")
    }
  };

  await axios
    .get(apiEndpoint, config)
    .then(response => {
      const contentType = response.headers["content-type"].trim();
      const returnedFileName = `CEM_${product}_Instructions.pdf`;

      const blob = new Blob([response.data], { type: contentType });

      importedSaveAs(blob, returnedFileName);
    })
    .catch(error => {
      console.log(error);
    });
}

const Home = () => {
  return (
    <div>
      <p1>Helpfiles</p1>
    </div>
  );
};

const IBS = () => {
  useEffect(async () => {
    await downloadProductHelpFile("DB");
  });
  return (
    <div>
      <p>Downloading IBS help file</p>
    </div>
  );
};

const DC = () => {
  useEffect(async () => {
    await downloadProductHelpFile("DC");
  });
  return (
    <div>
      <p>Downloading DC help file</p>
    </div>
  );
};

const PABS = () => {
  useEffect(async () => {
    await downloadProductHelpFile("PABS");
  });
  return (
    <div>
      <p>Downloading PABS help file</p>
    </div>
  );
};

export const HelpHelper = observer(() => {
  return (
    <div>
      <Switch>
        <PrivateRoute exact path='/help' component={Home} allowClientAccess />
        <PrivateRoute exact path='/help/IBS' component={IBS} allowClientAccess />
        <PrivateRoute exact path='/help/DC' component={DC} allowClientAccess />
        <PrivateRoute exact path='/help/PABS' component={PABS} allowClientAccess />
      </Switch>
    </div>
  );


});
